// JsFromRoutes CacheKey 767cfe464fb5c1158ca1556b6739ab9f
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/voice_memo'),
}
